<tax-page-header titleText="login.title"></tax-page-header>

<form class="ui-kit-white-card" name="form" (ngSubmit)="logIn()">
  <tax-login-menu></tax-login-menu>
  <div class="ui-kit-white-card__body">
    <div class="card-content ui-kit-rows-layout">
      <tax-input
        [class.invalid]="hasError"
        [labelText]="'user.form.login'"
        [id]="'login'"
        name="login"
        [(ngModel)]="model.login"
        [required]="true"
        [autofocus]="true"
        [tabindex]="1"
      ></tax-input>

      <tax-password
        [labelText]="'user.form.password'"
        [id]="'password'"
        name="password"
        [(ngModel)]="model.secret"
        [topActionButton]="restorePasswordLink"
        [required]="true"
        [tabindex]="2"
      ></tax-password>
      <ng-template #restorePasswordLink>
        <span class="forgot_pass" routerLink="password-restore" translate
          >login.forget.password</span
        >
      </ng-template>

      <div class="white-card-bottom">
        <tax-checkbox
          [id]="'rememberMe'"
          name="rememberMe"
          [(ngModel)]="model.rememberMe"
          [labelText]="'login.credentials.remember'"
        ></tax-checkbox>
        <button class="button_blue" [disabled]="loading" translate>login.credentials.enter</button>
      </div>
    </div>

    <div class="card-pic ui-kit-centering-column">
      <svg-icon key="cashbox"></svg-icon>
      <div translate class="description">login.icon.description</div>
    </div>
  </div>
</form>
